import * as React from "react";
import {
    List, Datagrid, TextField, NumberField, BooleanField, EditButton, ShowButton, Edit, Create, Show,
    SimpleForm, SimpleShowLayout, TextInput, NumberInput, BooleanInput,
    DateField, Filter, DeleteButton
} from 'react-admin';

const FarmerFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索姓名/电话/村" source="key" alwaysOn />
    </Filter>
);

export const AgriServiceFarmerList = props => (
    <List {...props} filters={<FarmerFilter />} title="农户管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Name" label="姓名" />
            <TextField source="Phone" label="电话" />
            <TextField source="Village" label="所在村" />
            <TextField source="Address" label="地址" />
            <NumberField source="LandArea" label="耕地面积(亩)" />
            <TextField source="Crops" label="主要作物" />
            <BooleanField source="Verified" label="认证" />
            <DateField source="CreateTime" label="注册时间" showTime />
            <EditButton />
            <ShowButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const AgriServiceFarmerShow = props => (
    <Show {...props} title="农户详情">
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Name" label="姓名" />
            <TextField source="Phone" label="电话" />
            <TextField source="IDCard" label="身份证号" />
            <TextField source="Village" label="所在村" />
            <TextField source="Address" label="地址" />
            <TextField source="LandArea" label="耕地面积(亩)" />
            <TextField source="Crops" label="主要作物" />
            <TextField source="Verified" label="已认证" />
            <DateField source="CreateTime" label="注册时间" showTime />
        </SimpleShowLayout>
    </Show>
);

export const AgriServiceFarmerEdit = props => (
    <Edit {...props} title="编辑农户">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Name" label="姓名" />
            <TextInput source="Phone" label="电话" />
            <TextInput source="IDCard" label="身份证号" />
            <TextInput source="Village" label="所在村" />
            <TextInput source="Address" label="地址" />
            <NumberInput source="LandArea" label="耕地面积(亩)" />
            <TextInput source="Crops" label="主要作物" />
            <BooleanInput source="Verified" label="认证" />
        </SimpleForm>
    </Edit>
);

export const AgriServiceFarmerCreate = props => (
    <Create {...props} title="新建农户">
        <SimpleForm>
            <TextInput source="Name" label="姓名" />
            <TextInput source="Phone" label="电话" />
            <TextInput source="IDCard" label="身份证号" />
            <TextInput source="Village" label="所在村" />
            <TextInput source="Address" label="地址" />
            <NumberInput source="LandArea" label="耕地面积(亩)" />
            <TextInput source="Crops" label="主要作物" />
            <BooleanInput source="Verified" label="认证" defaultValue={false} />
        </SimpleForm>
    </Create>
);
